import { render, staticRenderFns } from "./CategoryPageContent.vue?vue&type=template&id=f7b5ebe8&scoped=true&"
import script from "./CategoryPageContent.vue?vue&type=script&lang=js&"
export * from "./CategoryPageContent.vue?vue&type=script&lang=js&"
import style0 from "./CategoryPageContent.vue?vue&type=style&index=0&id=f7b5ebe8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f7b5ebe8",
  null
  
)

export default component.exports